import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@app/components/button/button.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalLifemapCompletedComponent } from './modalLifemapCompleted.component';
import { LoaderModule } from '@shared/loader/loader.module';

@NgModule({
  imports: [ButtonModule, CommonModule, MatDialogModule, PlIconModule, TranslateModule, LoaderModule],
  declarations: [ModalLifemapCompletedComponent],
  exports: [ModalLifemapCompletedComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ModalLifemapCompletedModule {}
